import { ScoreType, AnimalScore } from '@/modules/score-type/@types';
import { jsonApiClient } from 'shared/model';

const api = jsonApiClient('Score');

export const getAnimalScore = (id: string, signal?: AbortSignal) => api.get<ScoreType[]>(id, { signal });
export const postAnimalScore = (id: string, animalScore: AnimalScore) => api.post<AnimalScore>(undefined, animalScore);
